import { render, staticRenderFns } from "./MobHomeSlide.vue?vue&type=template&id=137861c4&scoped=true"
import script from "./MobHomeSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./MobHomeSlide.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobHomeSlide.vue?vue&type=style&index=0&id=137861c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137861c4",
  null
  
)

export default component.exports